export const CLASSTING_API_URL = process.env.REACT_APP_API_URL
export const CLASSTING_OPEN_API_URL = process.env.REACT_APP_OPEN_API_URL
